export default {
  Login: 'auth/login',
  supportedLanguage: 'supported-language',
  setLang: 'set-lang',
  fetchLangTranslation: 'languages',
  fetchBusinessType: 'business-type/fetch-business-types',
  countries: 'country/fetch-all',
  createShop: 'shop/create-shop',
  userData: 'auth/user-data',
  globalSummary: 'global-summary',
  fetchAllSales: 'sales/fetch-sales',
  logout: 'auth/logout',
  fetchUserCurrencies: 'currency/fetch-shop-currencies',
  sellItem: 'sales/record-sales',
  fetchAllProducts: 'product/fetch-stock-products',
  newProduct: 'product/add-products',
  fetchProductCategory: 'product-category/fetch-product-categories',
  financeReport: 'funds/finance-report',
  fundHistoric: 'funds/history',
  topUpMoney: 'funds/top-up',
  archivedStock: 'product/fetch-archived-products',
  renewNewProduct: 'product/rew-product-stock',
  setDefaultCurrency: 'currency/set-default-currency',
  fetchAllCurrency: 'currency/fetch-currencies',
  addCurrency: 'currency/add-shop-currency',
  toggleCurrencyExchange: 'currency/toggle-currency-exchange',
  expenseHistory: 'funds/expenses-history',
  recordExpense: 'funds/record-expense',
  createExpenseCategory: 'funds/create-expense-category',
  fetchExpenseCategory: 'funds/fetch-expense-category',
  updateExpenseCategory: (id: number | string) => `funds/update-expense-category/${id}`,
  deleteExpenseCategory: (id: number | string) => `funds/delete-expense-category/${id}`,
  fetchCustomers: 'clients/fetch-all-clients',
  createClient: 'clients/create-client',
  addProductCategory: 'product-category/add-product-category',
  updateProductCategory: 'product-category/update-product-category',
  deleteProductCategory: 'product-category/delete',
  bulkAddProductCategories: 'product-category/upload-product-category',
  importProductCategoriesExcel: 'product-category/import-excel',
  downloadCategoryTemplate: 'product-category/download-template',
  fetchProductItems: 'product/fetch-product-items',
  updateProductItem: 'product/update-product',
  salesAnalytics: 'analytics/sales',
  customerAnalytics: 'analytics/customers/dashboard',
  fetchLoans: 'sales/loans',
  fetchUsers: 'auth/users',
  addProductToStock: 'product/add-product-item-stock',
  loanPayment: 'sales/loan-payment',
  userRoles: 'user-role/fetch-user-roles',
  addNewUserRole: 'user-role/record-new-user-role',
  deleteSale: 'sales/remove-sales',
  loanPaymentHistory: 'sales/loan-payment-history',
  managePermission: 'user-role/manage-permission',
  rolePermissions: 'user-role/role-permissions',
  updateUserProfile: 'auth/update-user-profile',
  userPermissions: 'user-role/user-permissions',
  userPermissionOverride: 'auth/manage-permission',
  removeStockProduct: 'product/remove-stock-prod',
  resetPassword: 'auth/reset-password',
  createBranch: 'branch/create-shop-branch',
  fetchBranches: 'branch/fetch-branches',
  fetchStockLocations: 'stock/locations',
  updateShopBranch: (id: number | string) => `branch/update-shop-branch/${id}`,
  deleteShopBranch: (id: number | string) => `branch/delete-shop-branch/${id}`,
  fetchSuppliers: 'supplier/fetch-suppliers',
  addSupplier: 'supplier/add-supplier',
  updateSupplier: 'supplier/update-supplier',
  supplierStats: 'supplier/supplier-stats',
  bulkDeleteSuppliers: 'supplier/bulk-delete-suppliers',
  exportSuppliers: 'supplier/export-suppliers',
  loanAnalytics: 'sales/loan-analytics',
  addBranchUser: 'branch/add-branch-users',
  fetchBranchUsers: 'branch/fetch-branch-users',
  removeProductitem: 'product/remove-products',
  transferProducts: 'branch/transfer-products',
  allBranchesStock: 'branch/all-branches-stock',
  branchStockDetails: 'branch/branch-stock',
  updateBranchStock: 'branch/update-branch-stock',
  changeLanguage: 'auth/change-language',
  updatePrinterSettings: 'auth/shop/printer-settings',
  updateShopProfile: 'auth/shop/update-profile',
  registerUser: 'auth/register',
  publicReceiptPdf: (tabNumber: string) => `/public/receipt/${tabNumber}/pdf`,

  // V2
  getProductUnits: (id: number | string) => `/v2/products/${id}/units`,
  createSaleV2: '/v2/sales/create',
  pricingPreview: 'v2/sales/pricing/preview',
  stockV2: (id: number | string) => `/v2/stock/${id}`,
  bulkRestock: '/v2/stock/bulk-restock',
  stockAnalytics: '/v2/analytics/stock',
  createProductUnit: (id: number | string) => `/v2/products/${id}/units`,
  updateProductUnit: (productId: number | string, unitId: number | string) =>
    `/v2/products/${productId}/units/${unitId}`,
  deleteProductUnit: (productId: number | string, unitId: number | string) =>
    `/v2/products/${productId}/units/${unitId}`,
  salesHistoryV2: '/v2/sales/history',
  getReceiptDetails: (txnNumber: string | number) => `/v2/sales/history/${txnNumber}`,

  // Procurement (Purchase Orders & Delivery Notes)
  deliveryNotes: '/delivery-notes/fetch-delivery-notes',
  createDeliveryNote: '/delivery-notes/create-delivery-note',
  deliveryNoteDetails: (id: number | string) => `/delivery-notes/delivery-note/${id}`,
  updateDeliveryNoteQC: (id: number | string) => `/delivery-notes/${id}/qc`,
  purchaseOrders: '/purchase-orders/fetch-purchase-orders',
  createPurchaseOrder: '/purchase-orders/0', // PUT /{id} creates a new PO in backend logic
  approvePurchaseOrder: (id: number | string) =>
    `/purchase-orders/approve-purchase-order/${id}`,
  cancelPurchaseOrder: (id: number | string) =>
    `/purchase-orders/cancel-purchase-order/${id}`,
  purchaseOrderDetails: (id: number | string) =>
    `/purchase-orders/purchase-order/${id}`,

  // Bar Management - Comptoirs (Bar Counters)
  barComptoirs: '/bar/comptoir/comptoirs',
  createComptoir: '/bar/comptoir/comptoirs',
  getComptoirStock: (id: number | string) =>
    `/bar/comptoir/${id}/stock`,
  restockComptoir: '/bar/comptoir/restock',
  transferBetweenComptoirs: '/bar/comptoir/transfer',
  getLowStockAlerts: '/bar/comptoir/low-stock-alerts',
  getStockMovements: '/bar/comptoir/stock-movements',

  // Bar Management - Recipes & Cocktails
  barRecipes: '/bar/recipes',
  createRecipe: '/bar/recipes',
  getRecipeById: (id: number | string) => `/bar/recipes/${id}`,
  updateRecipe: (id: number | string) => `/bar/recipes/${id}`,
  deleteRecipe: (id: number | string) => `/bar/recipes/${id}`,
  recalculateRecipeCost: (id: number | string) =>
    `/bar/recipes/${id}/recalculate-cost`,
  getRecipeProfitability: '/bar/recipes/analytics/profitability',
  getPopularRecipes: '/bar/recipes/analytics/popular',

  // Bar Management - Pour Cost & Variance
  calculatePourCostVariance: '/bar/pour-cost/variance/calculate',
  getPourCostVariance: '/bar/pour-cost/variance',

  // Bar Management - Menus
  barMenus: '/bar/menus',
  createMenu: '/bar/menus',
  getMenuById: (id: number | string) => `/bar/menus/${id}`,
  updateMenu: (id: number | string) => `/bar/menus/${id}`,
  deleteMenu: (id: number | string) => `/bar/menus/${id}`,
  createMenuCategory: '/bar/menus/categories',
  addMenuItem: '/bar/menus/items',
  updateMenuItem: (id: number | string) => `/bar/menus/items/${id}`,
  uploadMenuItemImage: (id: number | string) => `/uploads/menu-item-image/${id}`,

  // Bar Management - Tabs (Customer Tabs/Bills)
  barTabs: '/bar/tabs',
  createTab: '/bar/tabs',
  getTabById: (id: number | string) => `/bar/tabs/${id}`,
  addItemToTab: (id: number | string) => `/bar/tabs/${id}/items`,
  closeTab: (id: number | string) => `/bar/tabs/${id}/close`,

  // Bar Management - Shifts
  barShifts: '/bar/shifts',
  createShift: '/bar/shifts',
  getShiftById: (id: number | string) => `/bar/shifts/${id}`,
  closeShift: (id: number | string) => `/bar/shifts/${id}/close`,
  recordShiftIncident: (id: number | string) =>
    `/bar/shifts/${id}/incidents`,
  getBartenderPerformance: (bartenderId: number | string) =>
    `/bar/shifts/performance/${bartenderId}`,

  // Bar Management - Bottles
  trackBottle: '/bar/bottles',
  getBottleById: (id: number | string) => `/bar/bottles/${id}`,
  openBottle: (id: number | string) => `/bar/bottles/${id}/open`,
  recordPour: (id: number | string) => `/bar/bottles/${id}/pour`,
  getBottlePourHistory: (id: number | string) => `/bar/bottles/${id}/pours`,

  // Bar Management - Servings & Sales
  serveByGlass: '/bar/servings/serve-glass',
  serveByBottle: '/bar/servings/serve-bottle',
  serveRecipe: '/bar/servings/serve-recipe',

  // Bar Management - Reports
  comptoirDailyReport: (id: number | string) =>
    `/bar/comptoir/reports/daily/${id}`,
  comptoirWeeklyReport: (id: number | string) =>
    `/bar/comptoir/reports/weekly/${id}`,
  comptoirMonthlyReport: (id: number | string) =>
    `/bar/comptoir/reports/monthly/${id}`,
  bartenderPerformanceReport: '/bar/comptoir/reports/bartender-performance',
  inventoryShrinkageReport: '/bar/comptoir/reports/inventory-shrinkage',

  // Pharmacy Management
  pharmacyStatus: 'pharmacy/status',
  pharmacyProfile: 'pharmacy/profile',
  enablePharmacy: 'pharmacy/enable',
  updatePharmacyProfile: 'pharmacy/profile',

  // Footwear & Shoe Service
  shoeItems: 'shoe/items',
  shoeAudit: 'shoe/display-samples/audit',
  shoeCareOrders: 'shoe/care-orders',
  shoeConversions: (sizeEu: number | string) => `shoe/conversions?size_eu=${sizeEu}`,

  // Clothing & Apparel Service
  clothingItems: 'clothing/items',
  clothingAudit: 'clothing/trial-room/audit',
  clothingAlterations: 'clothing/alterations',
  clothingFittingRooms: 'clothing/fitting-rooms',

  // Hardware & Building Supplies Service
  hardwareItems: 'hardware/items',

  // Medications
  // Medications
  medicationMetaOptions: 'pharmacy/medications/meta-options',
  medications: 'pharmacy/medications',
  createMedication: 'pharmacy/medications',
  getMedication: (id: number | string) => `pharmacy/medications/${id}`,
  updateMedication: (id: number | string) => `pharmacy/medications/${id}`,
  deleteMedication: (id: number | string) => `pharmacy/medications/${id}`,

  // Medication Batches
  // Medication Batches
  medicationBatches: 'pharmacy/medications/batches',
  createBatch: 'pharmacy/medications/batches/create',
  updateBatch: (medicationId: number | string, batchId: number | string) =>
    `pharmacy/medications/${medicationId}/batches/${batchId}`,

  // Prescriptions
  prescriptions: 'pharmacy/prescriptions',
  createPrescription: 'pharmacy/prescriptions/create',
  getPrescription: (id: number | string) => `pharmacy/prescriptions/${id}`,
  updatePrescription: (id: number | string) => `pharmacy/prescriptions/${id}`,
  verifyPrescription: (id: number | string) =>
    `pharmacy/prescriptions/${id}/verify`,
  dispensePrescription: (id: number | string) =>
    `pharmacy/prescriptions/${id}/dispense`,
  revertDispense: (id: number | string) =>
    `pharmacy/prescriptions/${id}/revert-dispense`,
  convertPrescriptionToSale: (id: number | string) =>
    `pharmacy/prescriptions/${id}/convert-to-sale`,

  // Patients
  // Patients
  patients: 'pharmacy/patients',
  createPatient: 'pharmacy/patients',
  getPatient: (id: number | string) => `pharmacy/patients/${id}`,
  updatePatient: (id: number | string) => `pharmacy/patients/${id}`,
  patientHistory: (id: number | string) => `pharmacy/patients/${id}/history`,

  // Pharmacists
  // Pharmacists
  pharmacists: 'pharmacy/pharmacists',
  createPharmacist: 'pharmacy/pharmacists',
  getPharmacist: (id: number | string) => `pharmacy/pharmacists/${id}`,
  updatePharmacist: (id: number | string) => `pharmacy/pharmacists/${id}`,

  // Pharmacy Sales
  pharmacySales: 'pharmacy/sales/sales',
  getPharmacySale: (id: number | string) => `pharmacy/sales/sales/${id}`,
  dispenseMedication: 'pharmacy/sales/dispense',
  getDispenseHistory: 'pharmacy/sales/history',

  // Pharmacy Dashboard & Analytics
  pharmacyDashboard: 'pharmacy/dashboard/metrics',
  pharmacyAnalytics: 'pharmacy/dashboard/analytics',
  expiryReport: 'pharmacy/medications/batches/expiry-report',
  lowStockMedications: 'pharmacy/dashboard/low-stock-alerts',
  prescriptionAnalytics: 'pharmacy/dashboard/prescription-analytics',

  // Stock Transfers
  stockTransfers: 'pharmacy/stock-transfers',
  stockTransferDetails: (id: number | string) => `pharmacy/stock-transfers/${id}`,
  approveTransfer: (id: number | string) => `pharmacy/stock-transfers/${id}/approve`,
  shipTransfer: (id: number | string) => `pharmacy/stock-transfers/${id}/ship`,
  receiveTransfer: (id: number | string) => `pharmacy/stock-transfers/${id}/receive`,
  cancelTransfer: (id: number | string) => `pharmacy/stock-transfers/${id}/cancel`,

  // Purchase Orders
  pharmacyPurchaseOrders: 'pharmacy/purchase-orders',
  pharmacyPurchaseOrderDetails: (id: number | string) => `pharmacy/purchase-orders/${id}`,
  updatePO: (id: number | string) => `pharmacy/purchase-orders/${id}`,
  submitPO: (id: number | string) => `pharmacy/purchase-orders/${id}/submit`,
  approvePO: (id: number | string) => `pharmacy/purchase-orders/${id}/approve`,
  markPOAsOrdered: (id: number | string) => `pharmacy/purchase-orders/${id}/order`,
  cancelPO: (id: number | string) => `pharmacy/purchase-orders/${id}/cancel`,

  // Goods Receiving
  goodsReceivingNotes: 'pharmacy/goods-receiving',
  grnDetails: (id: number | string) => `pharmacy/goods-receiving/${id}`,
  updateGRN: (id: number | string) => `pharmacy/goods-receiving/${id}`,
  qualityCheckGRN: (id: number | string) => `pharmacy/goods-receiving/${id}/quality-check`,
  postToInventory: (id: number | string) => `pharmacy/goods-receiving/${id}/post-to-inventory`,
  auditLogs: 'audit',
  superAdminShops: 'shop/all',
  superAdminSuspendShop: (id: number | string) => `shop/suspend/${id}`,
  superAdminDeleteShop: (id: number | string) => `shop/delete/${id}`,

  superAdminUsers: 'auth/admin/all-users',
  superAdminBlockUser: 'auth/block-user-account',

  superAdminLogs: 'audit/admin/all-logs',
  superAdminStats: 'admin/stats',
  superAdminTransactions: 'admin/payment-transactions',
  superAdminSupportedLanguages: 'supported-language',
  superAdminAddLanguage: 'add-language',
  superAdminUpdateLanguage: 'update-language',
  superAdminCurrencies: 'currency/fetch-currencies',
  superAdminAddCurrency: 'currency/add-currency',
  superAdminAddBusinessType: 'business-type/record-new-business-type',
  superAdminUpdateBusinessType: 'business-type/update-business-type',
  superAdminDeleteBusinessType: (id: number | string) => `business-type/delete-business-type/${id}`,

  // Super Admin Storefront & GMV Tracking
  superAdminStorefrontOverview: 'admin/storefronts/overview',
  superAdminStorefrontsList: 'admin/storefronts/list',
  superAdminStorefrontStatus: (id: number | string) => `admin/storefronts/${id}/status`,
  superAdminGlobalOrders: 'admin/storefronts/global-orders',
  superAdminConversionFunnel: 'admin/storefronts/conversion-funnel',
  superAdminStorefrontAnalytics: 'admin/storefronts/analytics',


  // Restaurant
  restaurantStats: 'restaurant/stats',
  restaurantTables: 'restaurant/tables',
  restaurantReservations: 'restaurant/reservations',
  restaurantKitchenTickets: 'restaurant/kitchen/tickets',
  restaurantKitchenStations: 'restaurant/kitchen/stations',
  restaurantKitchenInventory: 'restaurant/kitchen/inventory',
  restaurantKitchenMovements: 'restaurant/kitchen/movements',
  updateTableStatus: (id: number | string) => `restaurant/tables/${id}/status`,
  updateKitchenTicketStatus: (id: number | string) => `restaurant/kitchen/tickets/${id}/status`,
  updateRestaurantReservationStatus: (id: number | string) => `restaurant/reservations/${id}/status`,
  restaurantTableSessions: 'restaurant/tables/sessions',
  assignTableWaiter: (id: number | string) => `restaurant/tables/${id}/assignment`,
  transferTabWaiter: (id: number | string) => `restaurant/tabs/${id}/transfer`,
  restaurantTabOwnershipHistory: (id: number | string) => `restaurant/tabs/${id}/ownership-history`,

  // File Uploads
  uploadProfilePicture: 'uploads/profile-picture',
  uploadShopLogo: 'uploads/shop-logo',
  deleteProfilePicture: 'uploads/profile-picture',
  deleteShopLogo: 'uploads/shop-logo',

  // HRM & Payroll
  hrmEmployees: '/hrm/employees',
  hrmPayroll: '/hrm/payroll',
  createEmployee: '/hrm/employees',
  getEmployee: (id: number | string) => `/hrm/employees/${id}`,
  updateEmployee: (id: number | string) => `/hrm/employees/${id}`,
  deleteEmployee: (id: number | string) => `/hrm/employees/${id}`,
  salaryAdvances: '/hrm/salary-advances',
  approveSalaryAdvance: (id: number | string) => `/hrm/salary-advances/${id}/approve`,
  generatePayroll: '/hrm/payroll/generate',
  bulkGeneratePayroll: '/hrm/payroll/bulk-generate',
  approvePayroll: (id: number | string) => `/hrm/payroll/${id}/approve`,
  payrollHistory: '/hrm/payroll/history',
  payPayroll: (id: number | string) => `/hrm/payroll/${id}/pay`,
  payrollPaymentFile: '/hrm/payroll/payment-file',
  payrollStats: '/hrm/payroll/stats',
  payrollDetails: (id: number | string) => `/hrm/payroll/${id}/details`,
  updatePayroll: (id: number | string) => `/hrm/payroll/${id}`,
  cancelPayroll: (id: number | string) => `/hrm/payroll/${id}/cancel`,
  deletePayroll: (id: number | string) => `/hrm/payroll/${id}`,

  // Merchant Online Storefront & FUKKONI Lite
  merchantStorefrontDashboard: '/lite/dashboard',
  merchantStorefrontProducts: '/lite/products',
  merchantPublishProduct: (id: number | string) => `/lite/products/${id}/publish`,
  merchantStorefrontOrders: '/lite/orders',
  merchantUpdateOrderStatus: (id: number | string) => `/lite/orders/${id}/status`,
  merchantStorefrontSettings: '/lite/settings',
  merchantUpgradeToPro: '/lite/upgrade-to-pro',
  merchantDowngradeToLite: '/lite/downgrade-to-lite',
  merchantBusinessCategories: '/lite/business-categories',
  liteQuickRegister: '/lite/auth/quick-register',

  // Hotel & Hospitality PMS Management
  hotelRooms: '/hotel/rooms',
  hotelRoomsBulk: '/hotel/rooms/bulk',
  hotelRoomDetails: (id: number | string) => `/hotel/rooms/${id}`,
  hotelRoomStatus: (id: number | string) => `/hotel/rooms/${id}/status`,
  hotelRoomTypes: '/hotel/room-types',
  hotelRoomTypeDetails: (id: number | string) => `/hotel/room-types/${id}`,
  hotelReservations: '/hotel/reservations',
  hotelReservationDetails: (id: number | string) => `/hotel/reservations/${id}`,
  hotelReservationCheckIn: (id: number | string) => `/hotel/reservations/${id}/check-in`,
  hotelReservationCheckOut: (id: number | string) => `/hotel/reservations/${id}/check-out`,
  hotelReservationCancel: (id: number | string) => `/hotel/reservations/${id}/cancel`,
  hotelFolios: '/hotel/folios',
  hotelFolioDetails: (id: number | string) => `/hotel/folios/${id}`,
  hotelFolioCharges: (id: number | string) => `/hotel/folios/${id}/charges`,
  hotelFolioPayments: (id: number | string) => `/hotel/folios/${id}/payments`,
  hotelHousekeeping: '/hotel/housekeeping',
  hotelHousekeepingDetails: (id: number | string) => `/hotel/housekeeping/${id}`,
  hotelAnalytics: '/hotel/analytics',
  hotelWalkIn: '/hotel/rooms/walk-in',
  hotelGuests: '/hotel/guests',
  hotelGuestDetails: (id: number | string) => `/hotel/guests/${id}`,
  hotelReports: '/hotel/reports',
  hotelNightAudit: '/hotel/night-audit',
  hotelSeedData: '/hotel/seed-sample-data',
  hotelActiveInhouseRooms: '/hotel/active-inhouse-rooms',
  hotelChargeToRoom: '/hotel/charge-to-room',
};

